module.exports = __webpack_public_path__ + "img/teamImg17.6c75e0c7.jpg";